"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _service = require("./service");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _PublicTagModals = require("./PublicTagModals");

var _utils = require("./utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function showNewTagInList(pagination, tagsLength) {
  var pageSize = pagination.pageSize,
      page = pagination.page,
      total = pagination.total;
  return pageSize && page && total && page === Math.ceil(total / pageSize) && tagsLength < pageSize;
}

var AddPublicTag = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(AddPublicTag, _Component);

  var _super = _createSuper(AddPublicTag);

  function AddPublicTag() {
    var _this;

    (0, _classCallCheck2.default)(this, AddPublicTag);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      modalErrorMessage: undefined,
      showCreateModal: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onAddPublicTag", function () {
      _this.setState({
        showCreateModal: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCloseModal", function () {
      _this.setState({
        showCreateModal: false,
        modalErrorMessage: undefined
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClickModalInput", function () {
      _this.setState({
        modalErrorMessage: undefined
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "createTag", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(newTag) {
        var _this$props, pagination, setAlertMessage, setIsLoading, setTagsAndPagination, tags, responseData, newTags, newPagination, _err$response, _err$response$data, errorMessage;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = _this.props, pagination = _this$props.pagination, setAlertMessage = _this$props.setAlertMessage, setIsLoading = _this$props.setIsLoading, setTagsAndPagination = _this$props.setTagsAndPagination, tags = _this$props.tags;
                setIsLoading(true);

                if (newTag) {
                  _context.next = 6;
                  break;
                }

                _this.setState({
                  modalErrorMessage: 'Please enter tag name'
                });

                setIsLoading(false);
                return _context.abrupt("return");

              case 6:
                _context.prev = 6;
                _context.next = 9;
                return (0, _service.createTag)(newTag);

              case 9:
                responseData = _context.sent;
                newTags = tags;

                if (showNewTagInList(pagination, tags.length)) {
                  newTags.push({
                    id: responseData.id,
                    name: responseData.name,
                    count: 0
                  });
                }

                newPagination = pagination;
                newPagination.total = pagination.total ? pagination.total + 1 : pagination.total;

                _this.setState({
                  showCreateModal: false
                });

                setTagsAndPagination(newTags, newPagination);
                setAlertMessage("Public tag '".concat(responseData.name, "' has been added!"), 'success');
                _context.next = 24;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](6);
                errorMessage = ((_err$response = _context.t0.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.errors) || _utils.DEFAULT_ERROR_MESSAGE;

                _this.setState({
                  modalErrorMessage: errorMessage
                });

                setAlertMessage('', null);

              case 24:
                setIsLoading(false);

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[6, 19]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    return _this;
  }

  (0, _createClass2.default)(AddPublicTag, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          modalErrorMessage = _this$state.modalErrorMessage,
          showCreateModal = _this$state.showCreateModal;
      return (0, _preact.h)("div", null, (0, _preact.h)(_Button.default, {
        className: "qa-add-public-tag",
        variant: "brand",
        title: "Add public tag",
        onClick: this.onAddPublicTag
      }), showCreateModal && (0, _preact.h)(_PublicTagModals.EditModal, {
        onClose: this.onCloseModal,
        onClick: this.onClickModalInput,
        onSave: this.createTag,
        error: modalErrorMessage
      }));
    }
  }]);
  return AddPublicTag;
}(_preact.Component);

var _default = AddPublicTag;
exports.default = _default;